

export const PERSON_SPECIALITIES = [
  'Derecho familiar',
  'Defensa del consumidor',
  'Derecho civil',
  'Derecho educativo',
  'Derecho familiar',
  'Derecho inmobiliario',
  'Derecho laboral',
  'Derecho migratorio',
  'Derecho penal',
]

export const COMPANY_SPECIALITIES = [
  'Compliance',
  'Derecho administrativo',
  'Derecho corporativo',
  'Derecho laboral',
  'Derecho mercantil',
  'Derecho regulatorio',
  'Propiedad industrial'
]

export const ESTADOSITEMS = [
    'Aguascalientes' ,
    'Baja California' ,
    'Baja California Sur' ,
    'Campeche' ,
    'Chiapas' ,
    'Chihuahua' ,
    'CDMX' ,
    'Coahuila de Zaragoza' ,
    'Colima' ,
    'Durango' ,
    'Estado de México' ,
    'Guanajuato' ,
    'Guerrero' ,
    'Hidalgo' ,
    'Jalisco' ,
    'Michoacán de Ocampo' ,
    'Morelos' ,
    'Nayarit' ,
    'Nuevo León' ,
    'Oaxaca' ,
    'Puebla' ,
    'Querétaro' ,
    'Quintana Roo' ,
    'San Luis Potosí' ,
    'Sinaloa' ,
    'Sonora' ,
    'Tabasco' ,
    'Tamaulipas' ,
    'Tlaxcala' ,
    'Veracruz de Ignacio de la Llave' ,
    'Yucatán' ,
    'Zacatecas' ,
  ];

  export const SPECIALITIESANDSUBS = [
    'Anti corrupción',
    'Amparo',
    'Comercio internacional',
    'Compliance',
    'Derecho civil',
    'Derecho penal',
    'Derecho mercantil',
    'Derecho familiar',
    'Derecho laboral',
    'Derecho de seguridad social',
    'Derecho constitucional',
    'Derechos humanos',
    'Derecho fiscal',
    'Derecho administrativo',
    'Derecho corporativo',
    'Derecho de la propiedad intelectual',
    'Derecho energético',
    'Derecho en telecomunicaciones',
    'Defensa del consumidor',
    'Derecho aduanero',
    'Derecho agrario',
    'Derecho ambiental',
    'Derecho migratorio',
    'Derecho bancario',
    'Derecho canónico',
    'Derecho deportivo',
    'Derecho educativo',
    'Derecho electoral',
    'Derecho informático',
    'Derecho inmobiliario',
    'Derecho marítimo y aeronáutico',
    'Legislación médica',
    'Derecho militar',
    'Derecho minero y petrolero',
    'Derecho municipal',
    'Derecho tributario',
    'Derecho urbanístico',
    'Fusiones y adquisiciones',
    'Negligencia médica',
    'Norma 035',
    'Mediación y arbitraje',
    'Mercado de capitales',
    'Negligencias legales',
    'Propiedad industrial',
    'Propiedad intelectual',
    'Corredores públicos',
    'Peritos contables',
    'Peritos traductores',
    'Peritos valuadores',
    'Prevención de lavado',
    'Protección de datos personales',
    'Seguros / Fianzas',
    'Trámites ante el IMPI',
    'Ley General de Sociedades Mercantiles',
    'Responsabilidad administrativa',
    'Derecho empresarial y corporativo',
    'Normas jurídicas empresariales',
    'Acceso a la educación gratuita (Preescolar, Primaria, Secundaria y Media superior)',
    'Libertad de tránsito (Derechos la libertad de tránsito)',
    'Separaciones y divorcios de mutuo acuerdo o contenciosos.',
    'Derecho de propiedad y otros derechos reales',
    'Derechos laborales',
    'Delitos dolosos y culposos',
    'Desalojos (Forzoso, morosidad e incausado)',
    'Menores (Patria potestad, guarda y custodia, pensiones alimenticias, régimen de visitas)',
    'Contratos comerciales internacionales',
    'Responsabilidad civil por daños y perjuicios'
  ];

  export const ESPECIALIDADITEMS = [
    'Anti corrupción',
    'Amparo',
    'Comercio internacional',
    'Compliance',
    'Derecho civil',
    'Derecho penal',
    'Derecho mercantil',
    'Derecho familiar',
    'Derecho laboral',
    'Derecho de seguridad social',
    'Derecho constitucional',
    'Derechos humanos',
    'Derecho fiscal',
    'Derecho administrativo',
    'Derecho corporativo',
    'Derecho de la propiedad intelectual',
    'Derecho energético',
    'Derecho en telecomunicaciones',
    'Defensa del consumidor',
    'Derecho aduanero',
    'Derecho agrario',
    'Derecho ambiental',
    'Derecho migratorio',
    'Derecho bancario',
    'Derecho canónico',
    'Derecho deportivo',
    'Derecho educativo',
    'Derecho electoral',
    'Derecho informático',
    'Derecho inmobiliario',
    'Derecho marítimo y aeronáutico',
    'Legislación médica',
    'Derecho militar',
    'Derecho minero y petrolero',
    'Derecho municipal',
    'Derecho tributario',
    'Derecho urbanístico',
    'Fusiones y adquisiciones',
    'Negligencia médica',
    'Norma 035',
    'Mediación y arbitraje',
    'Mercado de capitales',
    'Negligencias legales',
    'Propiedad industrial',
    'Propiedad intelectual',
    'Corredores públicos',
    'Peritos contables',
    'Peritos traductores',
    'Peritos valuadores',
    'Prevención de lavado',
    'Protección de datos personales',
    'Seguros / Fianzas'
  ];

  export const LANGUAGES = [
    'Español',
    'Inglés',
    'Francés',
    'Italiano',
    'Alemán',
    'Portugués',
    'Chino',
    'Japonés',
  ]

  export const DAYS = [
    'Lunes',
    'Martes',
    'Miércoles',
    'Jueves',
    'Viernes',
    'Sábado',
    'Domingo'
  ]

  export const MONTH = [
    {value: '', name: 'Ninguno'},
    {value: 'Enero', name: 'Enero'},
    {value: 'Febrero', name: 'Febrero'},
    {value: 'Marzo', name: 'Marzo'},
    {value: 'Abril', name: 'Abril'},
    {value: 'Mayo', name: 'Mayo'},
    {value: 'Junio', name: 'Junio'},
    {value: 'Julio', name: 'Julio'},
    {value: 'Agosto', name: 'Agosto'},
    {value: 'Septiembre', name: 'Septiembre'},
    {value: 'Octubre', name: 'Octubre'},
    {value: 'Noviembre', name: 'Noviembre'},
    {value: 'Diciembre', name: 'Diciembre'},
  ]

  export const MONTH_NUMBER = [
    {value: '', name: 'Ninguno'},
    {value: '01', name: 'Enero'},
    {value: '02', name: 'Febrero'},
    {value: '03', name: 'Marzo'},
    {value: '04', name: 'Abril'},
    {value: '05', name: 'Mayo'},
    {value: '06', name: 'Junio'},
    {value: '07', name: 'Julio'},
    {value: '08', name: 'Agosto'},
    {value: '09', name: 'Septiembre'},
    {value: '10', name: 'Octubre'},
    {value: '11', name: 'Noviembre'},
    {value: '12', name: 'Diciembre'},
  ]

  export const YEAR = [
    {value: '', name: 'Ninguno'},
    {value: 1970, name: 1970},
    {value: 1971, name: 1971},
    {value: 1972, name: 1972},
    {value: 1973, name: 1973},
    {value: 1974, name: 1974},
    {value: 1975, name: 1975},
    {value: 1976, name: 1976},
    {value: 1977, name: 1977},
    {value: 1978, name: 1978},
    {value: 1979, name: 1979},
    {value: 1980, name: 1980},
    {value: 1981, name: 1981},
    {value: 1982, name: 1982},
    {value: 1983, name: 1983},
    {value: 1984, name: 1984},
    {value: 1985, name: 1985},
    {value: 1986, name: 1986},
    {value: 1987, name: 1987},
    {value: 1988, name: 1988},
    {value: 1989, name: 1989},
    {value: 1990, name: 1990},
    {value: 1991, name: 1991},
    {value: 1992, name: 1992},
    {value: 1993, name: 1993},
    {value: 1994, name: 1994},
    {value: 1995, name: 1995},
    {value: 1996, name: 1996},
    {value: 1997, name: 1997},
    {value: 1998, name: 1998},
    {value: 1999, name: 1999},
    {value: 2000, name: 2000},
    {value: 2001, name: 2001},
    {value: 2002, name: 2002},
    {value: 2003, name: 2003},
    {value: 2004, name: 2004},
    {value: 2005, name: 2005},
    {value: 2006, name: 2006},
    {value: 2007, name: 2007},
    {value: 2008, name: 2008},
    {value: 2009, name: 2009},
    {value: 2010, name: 2010},
    {value: 2011, name: 2011},
    {value: 2012, name: 2012},
    {value: 2013, name: 2013},
    {value: 2014, name: 2014},
    {value: 2015, name: 2015},
    {value: 2016, name: 2016},
    {value: 2017, name: 2017},
    {value: 2018, name: 2018},
    {value: 2019, name: 2019},
    {value: 2020, name: 2020},
  ]

  export const CEL_TYPE = [
    {value: '', name: 'Ninguno'},
    {value: 'Móvil', name: 'Móvil'},
    {value: 'Oficina', name: 'Oficina'},
    {value: 'Casa', name: 'Casa'},
  ]

  export const CONTACT_SOURCE = [
    {value: '', name: 'Ninguno'},
    {value: 'Contacta Abogado®', name: 'Contacta Abogado®'},
    {value: 'Recomendación', name: 'Recomendación'},
    {value: 'Otro', name: 'Otro'},
  ]

  export const CURRENCY = [
    {value: '', name: 'Ninguno'},
    {value: 'MXN Peso mexicano', name: 'MXN Peso mexicano'},
    {value: 'USD Dólar', name: 'USD Dólar'},
    {value: 'EUR Euro', name: 'EUR Euro'},
  ]

  export const COLLEGE = [
    {value: '', name: 'Ninguno'},
    {value: 'UNAM', name: 'UNAM'},
    {value: 'Politénico', name: 'Politénico'},
    {value: 'IBERO', name: 'IBERO'},
    {value: 'ITAM', name: 'ITAM'}
  ]

  export const COLLEGE_SINGLE = [
    '',
    'Politécnico',
    'UNAM',
    'IBERO',
    'ITAM',
  ]
    
  export const GRADESTUDY = [
    {value: '', name: 'Ninguno'},
    {value: 'Licenciatura', name: 'Licenciatura'},
    {value: 'Maestría', name: 'Maestría'},
    {value: 'Especialidad', name: 'Especialidad'},
    {value: 'Doctorado', name: 'Doctorado'}
  ]

  export const COLLABORATOR_POSITION = [
    {value: '', name: 'Ninguno'},
    {value: 'Abogado', name: 'Abogado'},
    {value: 'Socio', name: 'Socio'},
    {value: 'Asociado', name: 'Asociado'},
    {value: 'Pasante', name: 'Pasante'}
  ]

  export const MEMBERSHIP_TYPE = [
    {value: '', name: 'Ninguno'},
    {value: 'free', name: 'Free'},
    {value: 'premium', name: 'Premium'},
    {value: 'premium plus', name: 'Premium Plus'},
  ]

  export const MEMBERSHIP_STATUS = [
    {value: '', name: 'Ninguno'},
    {value: 'Activa', name: 'Activa'},
    {value: 'Suspendida', name: 'Suspendida'},
    {value: 'Pendiente', name: 'Pendiente'},
    {value: 'Cancelada', name: 'Cancelada'},
  ]

  export const HOURS = [
    '00:00',
    '01:00',
    '02:00',
    '03:00',
    '04:00',
    '05:00',
    '06:00',
    '07:00',
    '08:00',
    '09:00',
    '10:00',
    '11:00',
    '12:00',
    '13:00',
    '14:00',
    '15:00',
    '16:00',
    '17:00',
    '18:00',
    '19:00',
    '20:00',
    '21:00',
    '22:00',
    '23:00',
    '24:00'
  ]

  export const PROPOSAL_LIST_STATUS = [
    {value: '', name: 'Ninguno'},
    {value: 'Borrador', name: 'Borrador'},
    {value: 'Enviada', name: 'Enviada'},
    {value: 'Aceptada', name: 'Aceptada'},
    {value: 'Rechazada', name: 'Rechazada'},
  ]
  